export const OPEN_SIDEBAR = "OPEN_SIDEBAR";
export const CLOSE_SIDEBAR = "CLOSE_SIDEBAR";
export const FILTER_DASHBOARD = "FILTER_DASHBOARD";
export const ZONESELECTED_DASHBOARD = "ZONESELECTED_DASHBOARD";
export const CLEAR_FILTER = "CLEAR_FILTER";
export const ALLSTATUS_DASHBOARD = "ALLSTATUS_DASHBOARD";
export const CLEAR_ALLSTATUS = "CLEAR_ALLSTATUS";
export const GET_ALL_FILTERS_DATA = "GET_ALL_FILTERS_DATA";
export const SET_CREATION_DATE = "SET_CREATION_DATE";
export const CLEAR_CREATION_DATE = "CLEAR_CREATION_DATE";
export const CLEAR_WORKORDER_ID = "CLEAR_WORKORDER_ID";

export const setSidebar = (sidebarStatus) => {
    return {
        type: sidebarStatus ? OPEN_SIDEBAR : CLOSE_SIDEBAR,
        dashboard: {
            open: sidebarStatus,
        },
    };
};

export const filterDashboard = (filter) => {
    return {
        type: FILTER_DASHBOARD,
        filter,
    };
};

export const allStatusDashboard = (allStatuses) => {
    return {
        type: ALLSTATUS_DASHBOARD,
        allStatuses,
    };
};

export const zonesSelected = (zones) => {
    return {
        type: ZONESELECTED_DASHBOARD,
        zones,
    };
};

export const clearFilter = () => {
    return {
        type: CLEAR_FILTER,
    };
};

export const clearWorkOrderId = (data) => {
    return {
        type: CLEAR_WORKORDER_ID,
        data,
    };
};

export const clearAllStatus = () => {
    return {
        type: CLEAR_ALLSTATUS,
    };
};

export const getAllFiltersData = (data) => {
    return {
        type: GET_ALL_FILTERS_DATA,
        data,
    };
};
export const clearCreationDate = () => {
    return {
        type: CLEAR_CREATION_DATE,
    };
};

export const setCreationDate = (data) => {
    return {
        type: SET_CREATION_DATE,
        data,
    };
};
